export const whatsappNumber = "5511999999999";
export const whatsappLink = `https://wa.me/${whatsappNumber}?text=Ol%C3%A1%21%20Gostaria%20de%20conhecer%20as%20solu%C3%A7%C3%B5es%20LLK%20Bio%20Solutions.`;

export const llkProducts = [
  {
    id: "scudo-prime",
    name: "Scudo Prime",
    tagline: "Proteção Radicular Avançada",
    focus: "Manejo de fungos de solo e proteção do sistema radicular.",
    description: "Foco em proteção radicular, manejo de fungos de solo, equilíbrio microbiológico e desenvolvimento inicial.",
    features: [
      "Barreira biológica contra patógenos",
      "Fortalecimento da epiderme radicular",
      "Compatível com manejo integrado",
    ],
    image: "https://storage.readdy-site.link/project_files/08db1482-e90f-40f7-90d7-cbafb5b2411e/66c43649-e48c-4420-b70d-8f1efdc224a4_Scudo-prime-sem-fundo.png?v=f1a27a1327c08fa7940d7a64f1a43f93",
    badge: "Mais Vendido",
    bgGradient: "from-llk-dark to-llk-dark-2",
  },
  {
    id: "predador-prime",
    name: "Predador Prime",
    tagline: "Controle Biológico de Nematoides",
    focus: "Supressão biológica de nematoides fitoparasitas.",
    description: "Foco no manejo de pragas, nematoides, proteção contra pressões do solo e segurança radicular.",
    features: [
      "Ação microbiana direcionada",
      "Redução da pressão de nematoides",
      "Preservação da fauna benéfica do solo",
    ],
    image: "https://storage.readdy-site.link/project_files/08db1482-e90f-40f7-90d7-cbafb5b2411e/34c4672c-b1a0-4f51-992a-4efc5c89eaad_Predador-prime-sem-fundo.png?v=7b16aeba2b9c5884c6e2b8f3c22a250f",
    badge: null,
    bgGradient: "from-llk-dark-2 to-llk-dark-3",
  },
  {
    id: "bio-turbo",
    name: "Bio Turbo",
    tagline: "Ativação da Microbiota do Solo",
    focus: "Estímulo biológico da rizosfera e ciclagem de nutrientes.",
    description: "Apoia solubilização, raiz, arranque inicial e uniformidade da lavoura.",
    features: [
      "Repopulação microbiana eficiente",
      "Melhoria na disponibilidade de nutrientes",
      "Recuperação de áreas degradadas",
    ],
    image: "https://storage.readdy-site.link/project_files/08db1482-e90f-40f7-90d7-cbafb5b2411e/b90a4ab7-9e9d-4492-b973-1c8d35dfc550_Bio-Turbo-sem-fundo.png?v=e5f7c364c9d590a75b3a2c2da4320900",
    badge: null,
    bgGradient: "from-llk-dark-3 to-llk-dark",
  },
  {
    id: "bio-blend",
    name: "Bio Blend",
    tagline: "Sinergia Biológica para o Campo",
    focus: "Consórcio microbiano para múltiplas funções agrícolas.",
    description: "Apoia a atividade biológica do solo, o suporte vegetal e o equilíbrio microbiológico.",
    features: [
      "Sinergia entre diferentes cepas",
      "Ampliação do espectro de ação",
      "Resiliência em diferentes condições edafoclimáticas",
    ],
    image: "https://storage.readdy-site.link/project_files/08db1482-e90f-40f7-90d7-cbafb5b2411e/4212641b-b767-4140-9258-c5802fb42692_Bio-Blend-sem-fundo.png?v=abbe963ee251e262f7f76fc3e400f83e",
    badge: "Novo",
    bgGradient: "from-llk-dark-2 to-llk-dark",
  },
];

export const problems = [
  {
    title: "Raízes Vulneráveis",
    description: "Raízes mal protegidas expostas a patógenos do solo, reduzindo absorção de água e nutrientes.",
    icon: "ri-plant-line",
  },
  {
    title: "Baixa Eficiência Nutricional",
    description: "Solo com baixa atividade biológica, pouca solubilização e baixa absorção de nutrientes.",
    icon: "ri-seedling-line",
  },
  {
    title: "Pressão de Nematoides e Patógenos",
    description: "Infestação de nematoides e fungos de solo causando danos silenciosos e perda de vigor.",
    icon: "ri-virus-line",
  },
  {
    title: "Seca, Calor e Fases Críticas",
    description: "Estresse climático, solo desequilibrado e fragilidade em momentos decisivos do ciclo.",
    icon: "ri-sun-line",
  },
];

export const benefits = [
  {
    title: "Proteção Biológica da Raiz",
    description: "Escudo biológico que fortalece as raízes contra patógenos do solo e estresse ambiental.",
    icon: "ri-shield-star-line",
    color: "gold",
  },
  {
    title: "Manejo de Fungos de Solo",
    description: "Controle biológico direcionado a fitopatógenos que afetam o desenvolvimento radicular.",
    icon: "ri-shield-check-line",
    color: "green",
  },
  {
    title: "Controle Biológico de Nematoides",
    description: "Supressão biológica da pressão de nematoides, preservando a saúde da lavoura.",
    icon: "ri-virus-line",
    color: "gold",
  },
  {
    title: "Ativação da Microbiota",
    description: "Repopulação e equilíbrio da vida microbiana do solo para máxima eficiência.",
    icon: "ri-microscope-line",
    color: "green",
  },
  {
    title: "Melhor Aproveitamento de Nutrientes",
    description: "Ciclagem biológica que libera nutrientes e amplia a eficiência da adubação.",
    icon: "ri-seedling-line",
    color: "gold",
  },
  {
    title: "Mais Vigor e Uniformidade",
    description: "Lavouras mais fortes, homogêneas e resilientes em todas as fases do ciclo.",
    icon: "ri-bar-chart-grouped-line",
    color: "green",
  },
  {
    title: "Suporte em Fases Críticas",
    description: "Proteção e estímulo nos momentos mais decisivos do desenvolvimento da planta.",
    icon: "ri-time-line",
    color: "gold",
  },
  {
    title: "Manejo Sustentável",
    description: "Estratégia biológica que reduz impacto ambiental sem comprometer a produtividade.",
    icon: "ri-recycle-line",
    color: "green",
  },
];

export const phases = [
  {
    phase: "Plantio e Enraizamento",
    description: "Proteção inicial do sistema radicular e ativação da microbiota desde o primeiro contato com o solo.",
    products: ["Scudo Prime", "Bio Turbo"],
    icon: "ri-seedling-line",
  },
  {
    phase: "Crescimento Vegetativo",
    description: "Fortalecimento contínuo das raízes, manejo de fungos e controle da pressão de nematoides.",
    products: ["Scudo Prime", "Predador Prime"],
    icon: "ri-plant-line",
  },
  {
    phase: "Pré-Florada e Fase Reprodutiva",
    description: "Apoio biológico na fase de transição vegetativo-reprodutivo com máxima saúde radicular.",
    products: ["Bio Blend", "Scudo Prime"],
    icon: "ri-flower-line",
  },
  {
    phase: "Enchimento e Maturação",
    description: "Manutenção do vigor e eficiência nutricional para grãos e frutos de alta qualidade.",
    products: ["Bio Turbo", "Bio Blend"],
    icon: "ri-stack-line",
  },
  {
    phase: "Eficiência da Aplicação",
    description: "Garantia de que os biológicos atuem no momento certo, com máxima eficácia no campo.",
    products: ["Scudo Prime", "Bio Blend"],
    icon: "ri-flashlight-line",
  },
];

export const crops = [
  {
    name: "Cana-de-Açúcar",
    description: "Plantio, perfilhamento, crescimento, maturação e proteção do canavial.",
    icon: "ri-seedling-line",
  },
  {
    name: "Milho",
    description: "Tratamento de sementes, arranque, V3 a V6, pré-pendoamento e enchimento.",
    icon: "ri-drop-line",
  },
  {
    name: "Soja e Feijão",
    description: "Proteção radicular, pré-florada, pegamento de vagens e enchimento.",
    icon: "ri-plant-line",
  },
  {
    name: "Outras Culturas",
    description: "Orientação conforme solo, clima e objetivo produtivo.",
    icon: "ri-leaf-line",
  },
];

export const whyLLK = [
  {
    title: "Atendimento Consultivo",
    description: "Cada produtor recebe orientação técnica personalizada para sua cultura e realidade.",
    icon: "ri-customer-service-2-line",
  },
  {
    title: "Tecnologias Biológicas de Alta Performance",
    description: "Soluções desenvolvidas com rigor científico e comprovadas no campo.",
    icon: "ri-flask-line",
  },
  {
    title: "Biocontrole, Nutrição e Bioestimulação",
    description: "Abordagem integrada que protege, nutre e estimula a planta de forma sinérgica.",
    icon: "ri-magic-line",
  },
  {
    title: "Produtividade Sustentável",
    description: "Resultado real com redução de impacto ambiental e maior rentabilidade.",
    icon: "ri-line-chart-line",
  },
  {
    title: "Estratégias por Fase da Lavoura",
    description: "Indicação da tecnologia certa no momento certo, do plantio à maturação.",
    icon: "ri-calendar-todo-line",
  },
];

export const authorityPhrases = [
  "Mais proteção para a raiz.",
  "Mais equilíbrio para o solo.",
  "Mais vigor para a planta.",
  "Mais inteligência para o produtor.",
];